import * as React from "react";
import Row from "./row";
import * as Style from "./card.css";

export default (props: { children: React.ReactNode }) => (
  <div className={Style.card}>{props.children}</div>
);
